import { type FC } from "react";

import { Alert, Status } from "@snapchat/snap-design-system";

import { ClosableModal, ClosableModalBody, ClosableModalHeader, Flexbox } from "../../../shared/components";
import { type ModalProps } from "../../../shared/hooks";

import styles from "./GameLensCriteriaModal.module.css";
import {
    GameLensCriteriaGameplayLoopDescription,
    GameLensCriteriaGameplayLoopLabel,
    GameLensCriteriaGoalChallengeObjectiveDescription,
    GameLensCriteriaGoalChallengeObjectiveLabel,
    GameLensCriteriaModalSubtitle,
    GameLensCriteriaModalTitle,
    GameLensCriteriaSystemFeedbackDescription,
    GameLensCriteriaSystemFeedbackLabel,
    GameLensCriteriaUserInputDescription,
    GameLensCriteriaUserInputLabel,
} from "./messages.generated";

interface GameLensCriteriaModalProps {
    modalProps: ModalProps;
}

export const GameLensCriteriaModal: FC<GameLensCriteriaModalProps> = ({ modalProps }) => {
    return (
        <ClosableModal modalProps={modalProps}>
            <ClosableModalHeader>
                <GameLensCriteriaModalTitle />
            </ClosableModalHeader>
            <ClosableModalBody>
                <Flexbox className={styles.body} flexDirection="column" gap="var(--spacing-md)">
                    <Alert
                        closable={false}
                        status={Status.INFO}
                        title={
                            <h4 className={styles.subtitle}>
                                <GameLensCriteriaModalSubtitle />
                            </h4>
                        }
                    />
                    <Flexbox className={styles.criteriaList} flexDirection="column" gap="var(--spacing-md)">
                        <p className={styles.criteriaText}>
                            <strong className={styles.criteriaLabel}>
                                <GameLensCriteriaUserInputLabel />
                            </strong>{" "}
                            - <GameLensCriteriaUserInputDescription />
                        </p>
                        <p className={styles.criteriaText}>
                            <strong className={styles.criteriaLabel}>
                                <GameLensCriteriaGoalChallengeObjectiveLabel />
                            </strong>{" "}
                            - <GameLensCriteriaGoalChallengeObjectiveDescription />
                        </p>
                        <p className={styles.criteriaText}>
                            <strong className={styles.criteriaLabel}>
                                <GameLensCriteriaSystemFeedbackLabel />
                            </strong>{" "}
                            - <GameLensCriteriaSystemFeedbackDescription />
                        </p>
                        <p className={styles.criteriaText}>
                            <strong className={styles.criteriaLabel}>
                                <GameLensCriteriaGameplayLoopLabel />
                            </strong>{" "}
                            - <GameLensCriteriaGameplayLoopDescription />
                        </p>
                    </Flexbox>
                </Flexbox>
            </ClosableModalBody>
        </ClosableModal>
    );
};
